export const digits = [
  {number: 1, text: ''},
  {number: 2, text: 'ABC'},
  {number: 3, text: 'DEF'},
  {number: 4, text: 'GHI'},
  {number: 5, text: 'JKL'},
  {number: 6, text: 'MNO'},
  {number: 7, text: 'PQRS'},
  {number: 8, text: 'TUV'},
  {number: 9, text: 'WXYZ'},
  {number: '*', text: ''},
  {number: 0, text: '+'},
  {number: '#', text: ''},
]